<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="100px"
  >
    <el-form-item
        label="机器人名称"
        prop="robitName"
    >
      <el-input
          placeholder="请输入"
          v-model="form.robitName"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="描述"
        prop="desc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.desc"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="hook url"
        prop="hookUrl"
    >
      <el-input
          type="textarea"
          placeholder="请输入"
          v-model="form.hookUrl"
          :rows="4"
          resize="none"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="签名密钥"
      prop="signSecret"
    >
      <el-input
        v-model="form.signSecret"
        maxlength="255"
        autocomplete="new-password"
        placeholder="请输入飞书自定义机器人签名密钥（可选）"
      ></el-input>
      <div class="form-tip">{{editing ? '密钥已脱敏回显；不修改则保持原值，清空后提交将清除密钥。' : '开启飞书自定义机器人的“签名校验”后，请填写对应密钥。'}}</div>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
          v-model="form.status"
          :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  robitName: '',
  desc: '',
  hookUrl: '',
  signSecret: '',
  status: 1,
}
export default {
  name: "feishuForm",
  components:{
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        robitName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        desc:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        hookUrl:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        signSecret:[
          { validator: this.validateSignSecret, trigger: ['blur', 'change'] },
        ],
      },
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal){
        if(newVal){
            this.assign(newVal);
        }
      },
      deep:true,
    },
  },
  created(){
      if(this.formData.id){
          this.assign(this.formData);
      }
  },
  methods:{
      assign(formData){
          this.form.id = formData.id;
          this.form.robitName = formData.name;
          this.form.desc = formData.desc;
          this.form.hookUrl = formData.hookUrl;
          this.form.signSecret = typeof formData.signSecret === 'string' ? formData.signSecret : '';
          this.form.status = formData.status;
      },
    validateSignSecret(rule, value, callback){
      if(typeof value === 'string' && value.length > 255){
        callback(new Error('Lark机器人签名密钥最大长度不能超过255'));
      }else{
        callback();
      }
    },
    clearSignSecret(){
      this.form.signSecret = '';
    },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
  },
}
</script>

<style scoped>
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
</style>
